import React from 'react';
import Intl from '@fx-ui/intl';
import { Button, Result } from '@fx-ui/fine-design';
import EmptyImg from '~/assets/empty_status/box-tower-empty.png';
import { useBusinessLink, useStores } from '~/hooks';
import { getAddonActionText, getVipErrMsg, openInNewTab } from '~/utils';
import classNames from 'classnames';
import { Hyperlink } from '@fx-ui/jdy-design-biz';

interface IUpgradePaneProps {
    /**
     * number: 后端错误码
     * symbol：纯前端错误唯一标识
     */
    errorCode: number | string | symbol;
    className?: string;
}

/**
 * 高级功能不可用：升级/增购 Pane 提示
 * @param props
 */
const UpgradePane: React.FC<IUpgradePaneProps> = (props) => {
    const { errorCode, className } = props;
    const { corpUserStore } = useStores();
    const { purchaseLink } = useBusinessLink();

    const { title, msg, doc, allowAddon, isAddonUsage } = getVipErrMsg({
        corpUserStore,
        code: errorCode
    });

    return (
        <Result
            className={classNames('fx-upgrade-pane', className)}
            image={EmptyImg}
            title={title}
            description={
                <div>
                    {msg}
                    <Hyperlink href={doc} target="jdy_doc">
                        {Intl.get('vip.advancedFeatures')}
                    </Hyperlink>
                </div>
            }
        >
            {corpUserStore.hasSysAdmin && (
                <Button
                    className="upgrade-btn"
                    type="primary"
                    onClick={() => {
                        openInNewTab(purchaseLink);
                    }}
                >
                    {getAddonActionText(allowAddon, isAddonUsage)}
                </Button>
            )}
        </Result>
    );
};

export default UpgradePane;
